// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'number-decimal';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M13.536 11.016c.216.576.864 1.008 1.512 1.008.864 0 1.512-.648 1.512-1.512v-.216c0-.864-.648-1.512-1.512-1.512h-.072a1.29 1.29 0 0 0 1.296-1.296v-.216c0-.72-.576-1.224-1.224-1.224a1.26 1.26 0 0 0-1.008.504m-2.016 5.472H9v-.936c0-.504.288-1.008.72-1.296l1.512-.864c.432-.288.72-.792.72-1.296V7.56c0-.864-.648-1.512-1.512-1.512-.648 0-1.296.432-1.512 1.008m-5.976 4.968V5.976v.504a.984.984 0 0 1-1.008 1.008H1.44m3.024 4.536H1.44m5.04.576a.504.504 0 1 0 0-1.008.504.504 0 0 0 0 1.008z'
  />
);

export const viewBox = '0 0 18 18';
